// Loading skeleton for the chat transcript while a saved session's messages
// are being fetched. Pure presentational; aria-hidden so the role="log"
// container's aria-busy is the signal screen readers act on.

export function ChatHistorySkeleton() {
  return (
    <div className="space-y-3 animate-pulse" aria-hidden>
      <div className="flex justify-end">
        <div className="h-10 w-3/5 rounded-lg bg-slate-200" />
      </div>
      <div className="flex justify-start">
        <div className="h-16 w-4/5 rounded-lg bg-slate-100" />
      </div>
      <div className="flex justify-end">
        <div className="h-8 w-2/5 rounded-lg bg-slate-200" />
      </div>
      <div className="flex justify-start">
        <div className="h-20 w-[85%] rounded-lg bg-slate-100" />
      </div>
    </div>
  );
}
